<script>
	import {API, http_headers} from '../global.js'
	import {onMount} from 'svelte'
	export let data = {}
	
	let loading = false
	let auso = 'ENE'
	let oper_ds = []
	let puntos_ds = []
	let productos = []
	let filtro_producto = ''
	let operaciones = ''
	let filtro_oper= ''
	let isReady = false
	let clicked = 0
	let ver_obs = false

	async function getAuso(cli){	
		loading = true
		let query = `select dbo.fn_getAUso(${data.info.IdCliente}) as auso`
		let rs = await fetch(`${API}/exec-query	`,{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		auso = ds.success ? ds.data[0].auso?.trim() : 'ENE'
		loading = false			
	}

	async function getOperaciones(){
		loading = true
		let query = `select o.idoperacion,o.idproducto,p.descripcion producto,o.activo,o.puntos 
					from operaciones o
					left join productos p on p.idproducto=o.idproducto
					where o.idcliente=${data.info.IdCliente} and o.idproducto>1`
		let rs = await fetch(`${API}/exec-query	`,{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		oper_ds = ds.data
		productos = oper_ds.map( op => op.producto)
		productos = productos.filter( (op,idx) => productos.indexOf(op) == idx)
		filtro_producto = productos[0]
		operaciones = filtro_oper = oper_ds.filter(op => op.activo==1).map( op => op.idoperacion)

		loading = false
	}


	async function getPuntos(){
		loading = true
		let query = `select t.* from ( select  
            case when 'JUL'='${auso}' AND month(ccp.FechaAcreditacion)<7 AND ccp.IdProducto=2
                then year(ccp.FechaAcreditacion)-1
                else year(ccp.FechaAcreditacion)
                end as periodo,
              ccp.IdCtaCtePunto,
              ccp.IdCliente,
              ccp.IdOperacion,
              isnull((select activo from operaciones where idoperacion=ccp.IdOperacion),0) stat_op,
              convert(varchar(10),ccp.FechaCarga,103) FechaCarga,
              convert(varchar(10),ccp.FechaAcreditacion,103) FechaAcreditacion,
              convert(varchar(10),ccp.FechaAcreditacionOriginal,103) FechaAcreditacionOriginal,
              ccp.IdConceptoPunto,
              c.descripcion Concepto,
              ccp.Puntos,
              isnull((select puntos from operaciones where idoperacion=ccp.IdOperacion),0) puntos_op,
              ccp.Observacion,
              ccp.IdProducto,
              p.Descripcion Producto,
              ccp.IdEjecutivo,
              u.usuario Ejecutivo,
              ccp.Activo,
              ccp.IdVoucher       
            from ctactepuntos ccp 
            left join usuarios u on u.IdUsuario= ccp.IdEjecutivo
            left join conceptospuntos c on c.IdConceptoPunto= ccp.IdConceptoPunto
            left join productos p on p.IdProducto= ccp.IdProducto
            where ccp.idcliente = ${data.info.IdCliente} and ccp.activo=1 
            -- order by ccp.IdProducto,ccp.FechaAcreditacion,ccp.IdCtaCtePunto
            ) t ORDER by periodo desc, t.FechaAcreditacion, t.IdCtaCtePunto`
		let rs = await fetch(`${API}/exec-query	`,{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		puntos_ds = ds.data
		//console.log(puntos_ds)
		loading = false
	}

	$: make_table = async() =>{
		if(!isReady) return []
		let fromYear = (new Date).getFullYear()-10
		let data = puntos_ds.filter( v => v.periodo > fromYear).filter( v => v.Producto == filtro_producto)

		let agrupado = data.reduce( (v,i) => {
			v[i.periodo] = [...v[i.periodo] || [], i] 
			return v
		},{})

		let DS = []
		Object.keys(agrupado).forEach( (key) => {
			DS.push({
				periodo : key,
				movs : agrupado[key],
				saldo : agrupado[key].reduce( (acc,itm) => acc+itm.Puntos,0)
			})
			
		})
		return DS.reverse()
	}

	onMount( async ()=>{
		
		await getAuso()
		await getOperaciones()
		await getPuntos()
		isReady = true

	})

</script>

<div class="container-fluid" style="padding-bottom: 300px;">
	<p>Año de uso : {auso}</p>
	

	{#each oper_ds as oper, index}
	  <label class="{!oper.activo?'text-secondary':''}">
		<input class="mx-2" type="checkbox" bind:group={filtro_oper} name="filtro_oper" value={oper.idoperacion}>{oper.idoperacion} ({oper.producto} - {oper.puntos} Pts.)
	  </label>
	  <br>
	{/each}
	<hr>
	{#each productos as produ, index}
		<label>
			<input type=radio bind:group={filtro_producto} name="filtro_producto" value={produ} class="mx-2">{produ}
		</label>
	{/each}

	<hr>
	{#await make_table()}
		<p>Loading...</p>
	{:then agrup}
		<label>
			<input type="checkbox" bind:checked={ver_obs}> Observaciones
		</label>
		<table class="table table-sm">
		{#each agrup as item, index}
		
			<tr class="bg-warning">
				<td class="fw-bold ps-2">{item.periodo}</td>
				<td colspan=4 class="text-end fw-bold pe-2">Saldo : {item.saldo} Pts</td>
				<td>&nbsp;</td>
			</tr>

			{#each item.movs as mov, index}
				<tr>
					<td class="text-secondary">{mov.FechaCarga}</td>
					<td>{mov.Concepto}</td>
					<td>{mov.Puntos}</td>
					<td>{mov.FechaAcreditacion}</td>
					<td>{mov.IdOperacion}</td>
					<td>&nbsp;</td>
				</tr>	
				{#if ver_obs}
					<tr>
						<td class="fs-6 text-primary fst-italic">{mov.Ejecutivo}</td>
						<td class="fs-6 text-primary fst-italic" colspan=4>{mov.Observacion}</td>
					</tr>
				{/if}
			{/each}

		{/each}			
		</table>
		
		<!--
		<pre>{JSON.stringify(agrup,null,2)}</pre>
		<table class="table table-sm">
			<tr>
				<th>Periodo</th>
				<th>Concepto</th>
				<th>Puntos</th>
				<th>Acreditac</th>
				<th>Carga</th>
				<th>Operacion</th>
			</tr>
		{#each ds as item, index}
			<tr>
				<td>{item.periodo||''}</td>
				<td>{item.Concepto}</td>
				<td>{item.Puntos}</td>
				<td>{item.FechaAcreditacion}</td>
				<td>{item.FechaCarga}</td>
				<td>{item.IdOperacion}</td>
			</tr>
		{/each}
		</table>
	-->
	{/await}

</div>